import { ReactNode } from "react";
import { TagColor, TagSize, TagFill } from "..";
import "./index.css";

export function Tag({
  size = TagSize.DEFAULT,
  item,
  color = TagColor.DEFAULT,
  fill = TagFill.DEFAULT,
  children,
}: {
  size?: TagSize;
  item: string;
  color?: TagColor;
  fill?: TagFill;
  /** Shown under the item, inside the tag. */
  children?: ReactNode;
}) {
  return (
    <span className={`tag ${size} ${color} ${fill}`}>
      {item}
      {children}
    </span>
  );
}
